import type { ModalMobileMode, ModalSize, ModalWidthConfig } from './modal.types';

export const MODAL_BODY_PADDING = 2.5;

export const MODAL_WIDTH: Record<ModalSize, ModalWidthConfig> = {
  compact: { xs: 358, sm: 380 },
  standard: { xs: '100%', sm: 480 },
  expanded: { xs: '100%', sm: 640 },
  registration: { xs: '100%', sm: 999 },
};

export const MODAL_MOBILE_MODE: Record<ModalSize, ModalMobileMode> = {
  compact: 'dialog',
  standard: 'drawer',
  expanded: 'drawer',
  registration: 'fullscreen',
};
